module.exports = __webpack_public_path__ + "img/devices-lazy.d3d64af2.png";